const es = {
    checkout: {
        not_available: 'No se puede procesar <span>el pago</span>',
        loading: ''
    },
    payment: {
        loading: 'CARGANDO DATOS DE PAGO',
        another_method: 'Elija otro método de pago',
        received: 'Hemos recibido tu pago.',
        review: 'Revise su pedido',
        total: 'Total',
        choose_method: 'Elija su método de pago ',
        description: '*Tras el pago, le pediremos que introduzca su nombre y su fecha de nacimiento para que podamos generar su certificado de CI personalizado. (Precio con IVA incluido)',
        incl_vat: '*Precio incluye IVA. Se aplican las',
        terms: 'condiciones',
        result: {
            success: '¡Pago recibido!',
            error: 'Error en el proceso de pago. Elija otro método e inténtelo de nuevo.',
        }
    },
    common: {
        continue: 'Continuar',
        loading: 'CARGANDO DATOS',
        thanks: '¡Gracias!'
    },
    error: {
        click_here: 'Haga clic ',
        to_homepage: 'para volver a nuestra página principal'
    },
    info: {
        registry: 'Número de registro de empresa',
    },
    nav: {
        home: 'Inicio',
        jobs: 'Trabaja Con Nosotros',
        about_us: 'Sobre Nosotros',
        terms: 'Términos Del Servicio',
        gdpr: 'Protección De Datos',
        imprint: 'Aviso Legal',
        disclaimer: 'Descargo de responsabilidad: nuestro objetivo es desarrollar herramientas de evaluación de inteligencia y productos de entretenimiento de alta calidad. Por favor, no utilice nuestro contenido para tomar decisiones importantes en su vida o con el propósito de buscar consejo médico.'
    }
};

export default es;
